var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal-vue-d",
    {
      attrs: { name: _vm.name, width: "1140", "class-modal": "_city" },
      on: { "before-open": _vm.modalBeforeOpenHandler }
    },
    [
      _c(
        "div",
        {
          staticClass: "choose-city-order",
          class: { "_world-delivery": _vm.isWorldDelivery }
        },
        [
          _c(
            "div",
            { staticClass: "choose-city-order__heading" },
            [
              _c("div", { staticClass: "choose-city-order__title" }, [
                _vm._v("\n        Выберите город\n      ")
              ]),
              _vm._v(" "),
              !_vm.isWorldDelivery
                ? [
                    _c(
                      "div",
                      { staticClass: "choose-city-order__current" },
                      [
                        _c("icon", {
                          staticClass: "choose-city-order__inline-icon",
                          attrs: {
                            name: "Location_16",
                            width: "16",
                            height: "16"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", [_vm._v("Текущий город:")]),
                        _vm._v(" "),
                        _c(
                          "nobr",
                          { staticClass: "choose-city-order__current-name" },
                          [_c("b", [_vm._v(_vm._s(_vm.city.name))])]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "choose-city-order__detect-block" },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "choose-city-order__detect",
                            attrs: { href: _vm.jsv },
                            on: {
                              click: function($event) {
                                $event.preventDefault()
                                return _vm.detectClickHandler($event)
                              }
                            }
                          },
                          [
                            _c("icon", {
                              staticClass: "choose-city-order__inline-icon",
                              attrs: {
                                name: "location",
                                width: "16",
                                height: "16"
                              }
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.detectCaption) +
                                "\n          "
                            )
                          ],
                          1
                        )
                      ]
                    )
                  ]
                : _c("div", { staticClass: "choose-city-order__line-info" }, [
                    _c("div", { staticClass: "choose-city-order__city-info" }, [
                      _c(
                        "div",
                        { staticClass: "choose-city-order__current" },
                        [
                          _c("icon", {
                            staticClass: "choose-city-order__inline-icon",
                            attrs: {
                              name: "Location_16",
                              width: "16",
                              height: "16"
                            }
                          }),
                          _vm._v(" "),
                          _c("span", [_vm._v("Текущий город:")]),
                          _vm._v(" "),
                          _c(
                            "nobr",
                            { staticClass: "choose-city-order__current-name" },
                            [_c("b", [_vm._v(_vm._s(_vm.city.name))])]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "choose-city-order__detect-block" },
                        [
                          _c(
                            "a",
                            {
                              staticClass: "choose-city-order__detect",
                              attrs: { href: _vm.jsv },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.detectClickHandler($event)
                                }
                              }
                            },
                            [
                              _c("icon", {
                                staticClass: "choose-city-order__inline-icon",
                                attrs: {
                                  name: "location",
                                  width: "16",
                                  height: "16"
                                }
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.detectCaption) +
                                  "\n            "
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "choose-city-order__world-delivery" },
                      [
                        _c(
                          "world-delivery",
                          {
                            staticClass: "_d",
                            attrs: {
                              href: "/foreign-orders/",
                              target: "_blank"
                            }
                          },
                          [
                            _vm._v(
                              "\n            Международная доставка\n          "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ])
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "choose-city-order__search-wrapper" },
            [
              _c("search-field-city", {
                staticClass: "choose-city-order__search",
                attrs: { "outer-input-props": _vm.searchInputAttributes },
                on: { change: _vm.searchChangeHandler },
                model: {
                  value: _vm.foundCity,
                  callback: function($$v) {
                    _vm.foundCity = $$v
                  },
                  expression: "foundCity"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "choose-city-order__list" },
            [
              _c("city-list", {
                attrs: {
                  "region-opened": _vm.regionOpened,
                  "region-name": _vm.regionName,
                  "populars-marked": _vm.popularsMarked,
                  list: _vm.list
                },
                on: {
                  "popular-click": _vm.popularClickHandler,
                  "region-click": _vm.regionClickHandler,
                  "back-click": _vm.backClickHandler
                }
              })
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.loading ? _c("message-preloader") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }